import React from "react";
import Select from "react-select";

const defaultStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "2.25rem", // h-9
    height: "2.25rem",
    borderRadius: "0.375rem", // rounded-md
    borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb", // focus vs normal
    backgroundColor: "transparent",
    boxShadow: "none",
    fontSize: "0.875rem",
    "&:hover": {
      borderColor: "#e5e7eb",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#9ca3af", // gray-400
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#374151", // gray-700
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "0.75rem",
    marginTop: 0,
    backgroundColor: "white",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "0.875rem",
    backgroundColor: state.isFocused ? "#e0e7ff" : "white",
    color: "#374151",
    cursor: "pointer",
    padding: "4px 10px",
    borderRadius: "0.375rem", // rounded-xl
  }),
};

const SelectField = React.forwardRef(
  (
    {
      label,
      name,
      options = [],
      placeholder = "",
      error,
      disabled = false,
      className = "",
      styles = {},
      ...rest
    },
    ref
  ) => {
    // Format options to ensure { value, label } structure
    const formattedOptions = options.map((opt) =>
      typeof opt === "string"
        ? { value: opt, label: opt.charAt(0).toUpperCase() + opt.slice(1) }
        : opt
    );

    return (
      <div className={`${className}`}>
        {label && (
          <label className="ml-1.5 text-sm font-medium text-navy-700 dark:text-white">
            {label}
          </label>
        )}

        <div className="mt-0.5">
          <Select
            ref={ref}
            name={name}
            options={formattedOptions}
            placeholder={placeholder || `Select ${label?.toLowerCase()}`}
            isDisabled={disabled}
            styles={{ ...defaultStyles, ...styles }}
            {...rest}
          />
        </div>

        {error && (
          <p className="ml-1.5 mt-0.5 text-sm text-red-500">
            {typeof error === "string" ? error : error.message}
          </p>
        )}
      </div>
    );
  }
);

SelectField.displayName = "SelectField";
export default SelectField;
